import React, { useState } from "react";
import { FaCartPlus, FaTimes } from "react-icons/fa";
import Button from "../../../components/Button/Button";
import { toAbsoluteArticlePhotoUrl } from "../../../services/articlesPhotoServices";

export default function ArticleCard({
  id,
  nom,
  description,
  prix,
  taille,
  photo_url,
  is_stockable,
  is_stockage,
  quantite_stock,
  addToCart,
}) {
  const FALLBACK = "/img/no-image.jpg";

  const stockable = Boolean(is_stockable ?? is_stockage ?? false);
  const stockQty = Number(quantite_stock ?? 0);
  const isOutOfStock = stockable && stockQty <= 0;
  const formattedPrice = Number(prix || 0).toFixed(2);

  const imageSrc = photo_url
    ? toAbsoluteArticlePhotoUrl(photo_url)
    : FALLBACK;

  const [preview, setPreview] = useState(null);

  return (
    <article className="group rounded-2xl overflow-hidden bg-white/80 dark:bg-slate-900/60 backdrop-blur shadow ring-1 ring-slate-200/70 dark:ring-slate-800/70 flex flex-col h-full">
      <div
        className="relative overflow-hidden bg-slate-50 dark:bg-slate-900"
        style={{ aspectRatio: "4 / 3" }}
      >
        <img
          src={imageSrc}
          alt={nom}
          className="w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02] cursor-zoom-in"
          loading="lazy"
          onClick={() => setPreview(imageSrc)}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = FALLBACK;
          }}
        />

        {isOutOfStock && (
          <span className="absolute top-3 left-3 rounded-full bg-black/70 text-white text-xs px-2 py-1">
            Stock épuisé
          </span>
        )}
      </div>

      <div className="p-4 flex flex-col gap-3 flex-1">
        <div className="flex items-start justify-between gap-3">
          <h3 className="text-slate-900 dark:text-white text-base sm:text-lg font-semibold leading-tight">
            {nom}
          </h3>

          <div className="text-2xl font-bold text-slate-900 dark:text-slate-100 shrink-0">
            {formattedPrice} €
          </div>
        </div>

        <p className="text-sm text-slate-700 dark:text-slate-300">
          {description || (
            <span className="italic text-slate-500">Pas de description.</span>
          )}
        </p>

        <div className="text-sm text-slate-600 dark:text-slate-300 space-y-1">
          {taille && (
            <p>
              Taille : <span className="font-medium">{taille}</span>
            </p>
          )}

          {stockable && (
            <p>
              Stock :{" "}
              <span
                className={
                  stockQty > 0
                    ? "text-emerald-600 dark:text-emerald-400"
                    : "text-rose-600 dark:text-rose-400"
                }
              >
                {stockQty > 0 ? stockQty : "épuisé"}
              </span>
            </p>
          )}
        </div>

        <div className="mt-auto">
          <Button
            text={isOutOfStock ? "Stock épuisé" : "Ajouter au panier"}
            onClick={isOutOfStock ? undefined : addToCart}
            icon={FaCartPlus}
            className="w-full !rounded-xl gap-2"
            disabled={isOutOfStock}
          />
        </div>
      </div>

      {preview && (
        <div
          className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-sm grid place-items-center p-4"
          onClick={() => setPreview(null)}
        >
          <div
            className="relative max-w-3xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={preview}
              alt="Aperçu"
              className="w-full h-auto rounded-xl shadow-2xl"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = FALLBACK;
              }}
            />
            <button
              type="button"
              onClick={() => setPreview(null)}
              className="absolute -top-3 -right-3 h-9 w-9 rounded-full bg-white/90 text-slate-900 grid place-items-center shadow"
              aria-label="Fermer"
              title="Fermer l’aperçu"
            >
              <FaTimes />
            </button>
          </div>
        </div>
      )}
    </article>
  );
}